import Button from "Components/button";
import Scrollbars from "Components/scrollbars";
import ScrolledDropdown from "Components/scrolledDropdown";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import pick from "lodash/pick";
import React, { useCallback, useMemo } from "react";
import locale from "./welcome.locale";
const keySelector = (e) => e.Id;
const textSelector = (e) => e.Name;
const emptyList = [];
const SIZES = {
    LIST_WIDTH: 370,
    LIST_HEIGHT: 180,
    IMG_HEIGHT: 130
};
export default function Welcome(props) {
    const items = useMemo(() => props.availableDocumentObjectIds && props.documentObjects
        ? map(pick(props.documentObjects, props.availableDocumentObjectIds))
        : undefined, [props.documentObjects, props.availableDocumentObjectIds]);
    const handleGetTableData = useCallback(() => {
        props.onGetTableData && props.onGetTableData();
    }, [props.onGetTableData]);
    if (isEmpty(props.availableDocumentObjectIds))
        return null;
    return (React.createElement(Scrollbars, { wrapperClassName: true, className: classNames("stretched-to-fit", props.className) },
        React.createElement("div", { className: "d-grid h-100 v-center-items justify-content-center" },
            React.createElement("div", { className: "panel-body-padding text-center" },
                React.createElement("div", null,
                    React.createElement("h3", { className: "font-bold line-height-medium mt-0_75 text-light-on-background" }, locale.TABLE_SETTINGS),
                    React.createElement("div", { className: "text-light-on-surface-variant" }, locale.SELECT_DOCUMENT_OBJECTS)),
                React.createElement("div", { className: classNames(!items && "invisible", "mt-1_75 text-left bg-white border-light-outline-variant border-rounded-medium") },
                    React.createElement(ScrolledDropdown, { keySelector: keySelector, textSelector: textSelector, selectedKey: props.selectedDocumentObjectIds, multi: true, togglerComponent: null, searchInputMargins: false, itemClassName: "pl-0_75 text-on-surface", showSearchInputWhenItemsLengthIsGreaterThan: -1, onSelectedMultiChanged: props.onSelectDocumentObjects, items: items || emptyList, maxHeight: SIZES.LIST_HEIGHT, minHeight: SIZES.LIST_HEIGHT, height: SIZES.LIST_HEIGHT, minWidth: SIZES.LIST_WIDTH, maxWidth: SIZES.LIST_WIDTH, searchStylingMode: "underlined" })),
                React.createElement(Button, { className: "btn-primary mt-1_5", disabled: !props.selectedDocumentObjectIds, onClick: handleGetTableData }, locale.LOAD)))));
}
